import { render, staticRenderFns } from "./SearchableList.vue?vue&type=template&id=06d84008&scoped=true&"
import script from "./SearchableList.vue?vue&type=script&lang=js&"
export * from "./SearchableList.vue?vue&type=script&lang=js&"
import style0 from "./SearchableList.vue?vue&type=style&index=0&id=06d84008&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d84008",
  null
  
)

export default component.exports